import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { SubmitButton } from "./Button";
import { Modal } from "./Modal";

export function WhatIsThisModal(props: {
  children?: React.ReactNode;
  title: React.ReactNode;
}) {
  const [isVisible, setIsVisible] = useState(false);
  return (
    <>
      <Modal
        isVisible={isVisible}
        onCancel={() => setIsVisible(false)}
        buttonRow={
          <SubmitButton onClick={() => setIsVisible(false)}>OK</SubmitButton>
        }
        {...props}
      />
      <span
        className="click-catcher-small"
        onClickCapture={e => {
          e.preventDefault();
          setIsVisible(true);
        }}
      >
        <FontAwesomeIcon icon={faQuestionCircle} />
      </span>
    </>
  );
}
